// @flow
import React, { forwardRef } from "react";
import bem from "@justpark/helpers/src/bem/bem";
import type { Node } from "react";

import "./link.scss";
import Typography from "../Typography";

export type Props = {
  children: Node,
  className: string,
  cypress: string | null,
  href: string,
  onBlur: (event: SyntheticEvent) => any,
  onClick: (event: SyntheticEvent) => any,
  onFocus: (event: SyntheticEvent) => any,
  onKeyDown: (event: SyntheticEvent) => any,
  size: "h1" | "h2" | "h3" | "primary" | "secondary" | "subtext",
  tabIndex: number | null,
  type: "primary" | "secondary",
  target: null,
  rel: ?string,
  underline: boolean
};

/**
 * Styled hyperlinks.
 */
const Link = forwardRef(
  (
    {
      children,
      className,
      cypress,
      href,
      onBlur,
      onClick,
      onFocus,
      onKeyDown,
      size,
      tabIndex,
      type,
      target,
      rel,
      underline
    }: Props,
    ref
  ) => {
    const baseClass = "c-link";
    const color = type === "primary" ? "brand" : undefined;
    const bold = type === "primary";

    return (
      <Typography
        className={`${bem(baseClass, null, { underline })} ${className}`}
        color={color}
        bold={bold}
        size={size}
      >
        <a
          data-cy={cypress}
          href={href}
          onBlur={onBlur}
          onClick={onClick}
          onFocus={onFocus}
          onKeyDown={onKeyDown}
          ref={ref}
          tabIndex={tabIndex}
          target={target}
          rel={rel}
        >
          {children}
        </a>
      </Typography>
    );
  }
);

Link.defaultProps = {
  className: "",
  cypress: null,
  onBlur: () => {},
  onClick: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  size: Typography.defaultProps.size,
  tabIndex: null,
  type: "secondary",
  target: null,
  rel: "noopener noreferrer",
  underline: false
};

export default Link;
